import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Button, Grid, Grow, Paper, Typography, CircularProgress } from '@mui/material'
import { createTheme } from '@mui/material/styles'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import QuilityLevelTerm from '../images/Quility-Level-Term_Logo.svg'
import AvantLandingLogo from '../images/avant_landing_logo.svg'
import SBLILogo from '../images/sbli-logo.png'
import { AuthContext } from '../libs/contexts/authContext'
import QLTSecureFutureSelct from '../images/Quility-Secure-Future-Select_Logo.svg'
import { FetchAgentProducts } from '../libs/hooks/queries'
// import { useMediaQuery } from '@mui/material';

const defaultTheme = createTheme()

const LandingPageV3 = ({ toggleDrawer, ...props }) => {
  const { getAgentProduct, getAffiliateLoginInfo, productArray } = props
  // const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const { affiliateCode } = useContext(AuthContext)
  const [greyTermLife, setGreyTermLife] = useState(true)

  const { data: products, isLoading, isError } = FetchAgentProducts(affiliateCode)
  //   const [greyFinalExpense, setGreyFinalExpense] = useState(true)
  //   const [portalFlag, setPortalFlag] = useState(null)
  //   const [qltProduct, setQltProduct] = useState(null)
  //   const [feProduct, setFeProduct] = useState(null)

  useEffect(() => {
    if (!products) return
    console.log({ products })
  }, [products])

  const navigate = useNavigate()
  const currentLocation = window.location.href
  const newAppLink =
    currentLocation.includes('test') || currentLocation.includes('localhost')
      ? `https://bbq-eapp-qa.afficiency.com/?productId=511801&distributorId=5184&affiliateCode=${affiliateCode}`
      : currentLocation.includes('demo')
      ? `https://bbq-eapp-demo.afficiency.com/?productId=511801&distributorId=5184&affiliateCode=${affiliateCode}`
      : `https://bbq-eapp.afficiency.com/?productId=511801&distributorId=5184&affiliateCode=${affiliateCode}`
  return (
    // <div style={{ backgroundColor: '#F7F8FC', fontFamily: 'Roboto', minHeight: '100vh' }}>
    // <Grid
    //   container
    //   justifyContent="center"
    //   alignItems="center"
    //   sx={{ minHeight: '100vh', backgroundColor: '#F7F8FC', maxWidth: '100vw', overflow: 'hidden' }}
    // >

    <Box
      sx={{ minHeight: '100vh', backgroundColor: '#F7F8FC', maxWidth: '100vw', overflow: 'hidden' }}
      paddingTop={'50px'}
      display={'flex'}
      flexDirection={'column'}
      gap={20}
      alignItems={'center'}
    >
      <Typography variant="h1" style={{ padding: '50px 0px 70px 20px', fontSize: '36px' }}>
        Get a Life Insurance Policy within Minutes
      </Typography>
      <Grow in={true} timeout={1000}>
        <Paper
          variant={greyTermLife ? 'outlined' : 'elevation'}
          style={{
            borderRadius: '10px',
            position: 'relative',
            height: '520px',
            maxWidth: '50%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#fff',
            color: defaultTheme.palette.primary.main,
            padding: '0 60px',
            gap: '3.5rem',
            boxShadow: '0px 4px 20px -4px #10182814',
            border: 'none',
          }}
        >
          <Box
            component="img"
            src={AvantLandingLogo}
            sx={{
              width: '80%',
              padding: 'auto 100px',
              opacity: 1,
            }}
          />
          {!affiliateCode ? (
            <Typography display="flex" alignItems={'center'} justifyContent={'center'} color="#3C4FB9">
              {' '}
              <InfoOutlinedIcon sx={{ margin: '8px', color: '#3C4FB9' }} />
              Not Available
            </Typography>
          ) : isLoading ? (
            <CircularProgress size={'20px'} />
          ) : (
            <Button
              //   onClick={
              //     handleQLTSubmit
              //     }
              sx={homeStyle.updateInfoButton}
              onClick={() =>
                products && products.length > 0
                  ? window.open(products[0].productUrl, '_blank')
                  : window.open(newAppLink, '_blank')
              }
            >
              {/* <Typography sx={homeStyle.updateInfoText}> */}
              Quick Quote
              {/* </Typography> */}
            </Button>
          )}
        </Paper>
      </Grow>
    </Box>
  )
}

export default LandingPageV3

const homeStyle = {
  updateInfoText: {
    color: '#fff',
    fontFamily: 'Roboto',
    fontStyle: 'bold',
    fontWeight: 800,
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.1px',
  },

  updateInfoButton: {
    color: '#3C4FB9',
    fontFamily: 'Roboto',
    fontStyle: 'bold',
    fontWeight: 800,
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.1px',
    textTransform: 'none',
    border: '1px solid #3C4FB9',
    borderRadius: '25px',
    p: 1.5,
  },

  container: (theme) => ({
    display: 'flex',
  }),
  item: (theme) => ({
    border: '1px solid blue',
  }),
  itemFlexGrow: (theme) => ({
    flexGrow: 1,
    border: '1px solid red',
  }),
}
